import { AgentsPlagiarismIcon, Icon, type IconProps } from '@grammarly/design-system'

type PlagiarismAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const PlagiarismAgentIcon = ({ size, accessibilityLabel }: PlagiarismAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsPlagiarismIcon}
      accessibilityLabel={accessibilityLabel ?? 'Plagiarism Checker'}
    />
  )
}
